import lodash from "lodash";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import {
    createFieldAttachment,
    createFieldInput,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import { createColumnInput, createColumnInputNumber, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { conditionFormChecker, putField } from "../../../../utils/form";

const StorageLocationList = defineAsyncComponent(() => import("./storage-location/StorageLocationList"));

export const callHazMgtType = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_MGT_TYPE", value: searchQuery })
        .then(items => items.filter(item => ["1", "2"].includes(item.key)));
export const callHazMgtStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_MGT_STATUS", value: searchQuery });
export const callHaz = ({ searchQuery, refUserCompanyId }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        //{ name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },

        { name: "items.refHazLicense.refOperation.key", type: "String", operator: "in", value: ["1", "4", "5"] },
        { name: "items.refStorageLocationSub.refStorageLocation.refUserCompany.id", type: "UUID", operator: "=", value: refUserCompanyId }
        //{ name: "hazLicenseDetails.refHazLicense.refOperation.key", type: "String", operator: "in", value: ["1", "4", "5"] },
        //{ name: "refUserCompany.id", type: "UUID", operator: "=", value: refUserCompanyId }
    ];
    if (searchQuery) {
        where.push({ openBucket: true, name: "approveCode", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", name: "refHazObject.nameTh", type: "String", operator: "like", value: searchQuery });
        where.push({ closeBucket: true, logic: "OR", name: "tradeNameTh", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "approveCode", "refHazObject.id", "refHazObject.nameTh", "tradeNameTh", "refOperation.id", "refOperation.version", "refOperation.value"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callHazLicense = ({ searchQuery, hazId, refUserCompanyId }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        //{ name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
        { name: "refOperation.key", type: "String", operator: "in", value: ["1", "4", "5"] },
        { name: "hazLicenseDetails.refHaz.id", type: "UUID", operator: "=", value: hazId },

        { name: "hazLicenseDetails.refHaz.items.refHazLicense.refOperation.id", type: "Getpath", operator: "=", value: "refOperation.id" }
        //{ name: "hazLicenseDetails.refHazLicense.refOperation.id", type: "Getpath", operator: "=", value: "refOperation.id" }
    ];
    if (refUserCompanyId) {
        where.push({ name: "refUserCompany.id", type: "UUID", operator: "=", value: refUserCompanyId });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/hazLicense/search", {
            criteria: {
                isDistinct: true,
                select: [
                    "id",
                    "version",
                    "approveCode",
                    "refOperation.id",
                    "refOperation.version",
                    "refOperation.key",
                    "refOperation.value",
                    "refOperation.seq"
                ],
                children: [
                    {
                        name: "hazLicenseDetails",
                        select: ["id", "refHaz.id", "refHaz.refHazObject.id", "refHaz.refHazObject.nameTh", "refHaz.tradeNameTh"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    }
                ],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callUserCompany = ({ searchQuery, hazId, notId }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "isCeo", type: "Boolean", operator: "=", value: true },

        { name: "hazLicenses.isActive", type: "Boolean", operator: "=", value: true },
        { name: "hazLicenses.isTemp", type: "Boolean", operator: "=", value: false },
        { name: "hazLicenses.refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "hazLicenses.expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
        { name: "hazLicenses.refOperation.key", type: "String", operator: "in", value: ["2", "5"] },
        { name: "hazLicenses.hazLicenseDetails.refHaz.id", type: "UUID", operator: "=", value: hazId }
    ];
    if (notId) {
        //where.push({ name: "id", type: "UUID", operator: "!=", value: notId });
    }
    if (searchQuery) {
        where.push(
            { openBucket: true, name: "companyNameTh", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "fullNameTh", type: "String", operator: "like", value: searchQuery }
        );
    }
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "companyNameTh", "companyNameEn", "fullNameTh", "fullNameEn", "refPersonType.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "companyNameTh", type: "ASC" }]
            }
        })
        .then(page => page.data);
};
export const callStorageLocation = ({ searchQuery, refHazId, refHazLicenseId }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "isLocation", type: "Boolean", operator: "=", value: true },

        { name: "items.refHaz.id", type: "UUID", operator: "=", value: refHazId },
        { name: "items.refHazLicense.id", type: "UUID", operator: "=", value: refHazLicenseId }
        //{ name: "hazLicenseStorageLocations.refHazLicense.id", type: "UUID", operator: "=", value: refHazLicenseId }
    ];
    if (searchQuery) {
        where.push({ openBucket: true, name: "name", type: "String", operator: "like", value: searchQuery });
        where.push({ closeBucket: true, logic: "OR", name: "refUserCompany.fullNameTh", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/storageLocation/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "name", "refUserCompany.id", "refUserCompany.fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "refUserCompany.fullNameTh", type: "ASC" }, { name: "name", type: "ASC" }],
                children: [
                    {
                        name: "items",
                        select: ["*", "refStorageLocationSub.*"],
                        page: 0,
                        size: 1000000,
                        where: [
                            { name: "refHaz.id", type: "UUID", operator: "=", value: refHazId },
                            { name: "refHazLicense.id", type: "UUID", operator: "=", value: refHazLicenseId }
                        ],
                        sort: [
                            { name: "refStorageLocationSub.buildingName", type: "ASC" },
                            { name: "lot", type: "ASC" }
                        ]
                    }
                ]
            }
        })
        .then(page => page.data);
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.sellBuy.seller"),
            dataIndex: "refFrom.fullNameTh",
            dataIndexValue: ({ record }) => {
                return record.refFrom?.refPersonType?.key === "1" ? record.refFrom?.companyNameTh : record.refFrom?.fullNameTh;
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("views.sellBuy.buyer"),
            dataIndex: "refTo.companyNameTh",
            dataIndexValue: ({ record }) => {
                if (record.refType?.key === "1") {
                    return record.refTo?.refPersonType?.key === "1" ? record.refTo?.companyNameTh : record.refTo?.fullNameTh;
                } else if (record.refType?.key === "2") {
                    return record.toOther;
                }
                return null;
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refHaz"),
            dataIndex: "storageLocations.0.refHaz.approveCode",
            align: "center",
            search: { name: "storageLocations.refHaz.approveCode" },
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.tradeNameTh"),
            dataIndex: "storageLocations.0.refHaz.tradeNameTh",
            search: { name: "storageLocations.refHaz.tradeNameTh" },
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocation"),
            dataIndex: "storageLocations.0.refStorageLocation.name",
            search: { name: "storageLocations.refStorageLocation.name" },
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocationSub"),
            dataIndex: "storageLocations.0.refStorageLocationSub.buildingName",
            search: { name: "storageLocations.refStorageLocationSub.buildingName" },
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocationSubItem"),
            dataIndex: "storageLocations.0.refStorageLocationSubItem.lot",
            align: "center",
            width: 200,
            search: { name: "storageLocations.refStorageLocationSubItem.lot" },
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.hazMgtStorageLocation.amount"),
            dataIndex: "storageLocations.0.amount",
            align: "center",
            search: { name: "storageLocations.amount" },
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazMgt.refStatus"),
            dataIndex: "refStatus.attribute.sellText",
            inputProp: () => ({ list: callHazMgtStatus, optLabel: "attribute.sellText" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forFromRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.sellBuy.descToTo"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forFromRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forFromRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forToRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.sellBuy.descToFrom"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forToRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forToRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 }, colon: false }),
                label: () => i18n.global.t("model.hazMgt.refType"),
                labelRender: () => " ",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refType,
                            "onUpdate:value": value => {
                                model.refType = value;
                                lodash.remove(model.attachments, d => !d.id);
                                model.attachments.forEach(d => (d.isDelete = true));
                                if (value?.key === "1") {
                                    model.toOther = null;
                                } else if (value?.key === "2") {
                                    model.attachments.unshift({});
                                    model.refTo = null;
                                }
                            },
                            disabled: viewOnly,
                            list: callHazMgtType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}storageLocations.0.refHaz`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazMgtStorageLocation.refHaz"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.storageLocations[0]?.refHaz,
                            "onUpdate:value": value => {
                                model.storageLocations[0].refHaz = value;
                                model.storageLocations[0].refHazLicenseFrom = null;
                                model.refTo = null;
                                model.storageLocations[0].refStorageLocation = null;
                                model.storageLocations[0].refStorageLocationSub = null;
                                model.storageLocations[0].refStorageLocationSubItem = null;
                                model.storageLocations[0].amount = null;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callHaz({
                                    searchQuery,
                                    refUserCompanyId: store.state.resource.auth.info?.user?.refParent?.id || store.state.resource.auth.info?.user?.id
                                }),
                            renderLabel: ({ item }) => {
                                return <span>{item.approveCode}-{item.tradeNameTh || "ไม่มีข้อมูล"}-{item.refHazObject?.nameTh || "ไม่มีข้อมูล"}</span>;
                            },
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.approveCode`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}storageLocations.0.refHazLicenseFrom`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazMgtStorageLocation.refHazLicenseFrom"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.storageLocations[0]?.refHazLicenseFrom,
                            "onUpdate:value": value => {
                                model.storageLocations[0].refHazLicenseFrom = value;
                                model.storageLocations[0].refStorageLocation = null;
                                model.storageLocations[0].refStorageLocationSub = null;
                                model.storageLocations[0].refStorageLocationSubItem = null;
                                model.storageLocations[0].amount = null;
                            },
                            disabled: viewOnly || !model.storageLocations[0]?.refHaz,
                            list: ({ searchQuery }) =>
                                callHazLicense({
                                    searchQuery,
                                    hazId: model.storageLocations[0]?.refHaz?.id,
                                    refUserCompanyId: store.state.resource.auth.info?.user?.refParent?.id || store.state.resource.auth.info?.user?.id
                                }),
                            renderLabel: ({ item }) => {
                                const details = item.hazLicenseDetails?.map(d => `[${d.refHaz?.refHazObject?.nameTh}-${d.refHaz?.tradeNameTh}]`).join(", ");
                                return <span>
                                    {item.approveCode} ({item.refOperation?.value}) {details}
                                </span>
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.approveCode`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}storageLocations.0.refHaz.tradeNameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.tradeNameTh"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.storageLocations[0]?.refHaz?.tradeNameTh,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}storageLocations.0.refStorageLocation`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocation"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.storageLocations[0]?.refStorageLocation,
                            "onUpdate:value": value => {
                                model.storageLocations[0].refStorageLocation = value;
                                model.storageLocations[0].refStorageLocationSub = null;
                                model.storageLocations[0].refStorageLocationSubItem = null;
                                model.storageLocations[0].amount = null;
                            },
                            disabled: viewOnly || !model.storageLocations[0]?.refHaz || !model.storageLocations[0]?.refHazLicenseFrom,
                            list: ({ searchQuery }) =>
                                callStorageLocation({
                                    searchQuery,
                                    userInfo: store.state.resource.auth.info?.user,
                                    refHazId: model.storageLocations[0]?.refHaz?.id,
                                    refHazLicenseId: model.storageLocations[0]?.refHazLicenseFrom?.id
                                }),
                            renderLabel: ({ item }) => {
                                return <span>{item.refUserCompany?.fullNameTh} - {item.name}</span>;
                            },
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.name`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refTo`,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.sellBuy.buyer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refTo,
                            "onUpdate:value": value => (model.refTo = value),
                            disabled: viewOnly || !model.storageLocations[0]?.refHaz,
                            list: ({ searchQuery }) =>
                                callUserCompany({
                                    searchQuery,
                                    hazId: model.storageLocations[0]?.refHaz?.id,
                                    notId: store.state.resource.auth.info?.user?.refParent?.id || store.state.resource.auth.info?.user?.id
                                }),
                            renderLabel: ({ item }) => {
                                if (item.refPersonType?.key === "1") {
                                    return <div>{item.companyNameTh}</div>;
                                }
                                return <div>{item.fullNameTh}</div>;
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: {
                    getValue: ({ record, field }) =>
                        lodash.get(record, `${field.key}.${record.refPersonType?.key === "1" ? "companyNameTh" : "fullNameTh"}`)
                }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}toOther`,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.sellBuy.toOther"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.toOther,
                            "onUpdate:value": value => (model.toOther = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldAttachment({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachments.0`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.attachment.modelName"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.attachments?.[0]?.url || model.attachments?.[0]?.blob ? model.attachments?.[0] : null,
                            "onUpdate:value": value => {
                                const refAttach = model.attachments?.[0];
                                refAttach.name = value?.name;
                                refAttach.documentName = refAttach.documentName ? refAttach.documentName : value?.name;
                                refAttach.blob = value?.blob;
                                refAttach.isSave = value?.isSave;
                                refAttach.size = value?.size;
                                refAttach.type = value?.type;
                                refAttach.group = value?.group;
                            },
                            disabled: viewOnly,
                            fileListShowMode: "horizontal"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    );
                }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: { span: 16, offset: 8 } }),
                formItemRender: () => {
                    return <div class="text-danger">{i18n.global.t("views.sellBuy.remark")}</div>;
                }
            },
            {
                visible: () => model.storageLocations?.[0].refStorageLocation,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    model.storageLocations?.[0].refStorageLocation; // for refresh table
                    const componentProp = lodash.merge(
                        {
                            menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}storageLocations.0.refStorageLocation.items`,
                            itemKey: `${prefix}storageLocations.0`,
                            hazMgt: model
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "StorageLocationList" } })
                    );
                    return () => <StorageLocationList {...componentProp}></StorageLocationList>;
                }
            }
        ]
    });
};
